import { Button, Modal, ModalProps, styled } from '@mui/material';

import { IcArrowLeft, IcClose } from '@/assets/images';

import { CloseButton, ModalContent } from './styles';

interface SideModalProps extends Omit<ModalProps, 'onClose'> {
  onClose: () => void;
  width?: string;
  disableBackdropClick?: boolean;
  closingType?: 'close' | 'hide' | 'none';
}

const HideButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 46px;
  padding: 12px 4px;
  border-radius: 8px 0 0 8px;
  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  text-transform: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  .hide-icon {
    transform: rotate(180deg); /* arrow pointing left */
    margin-bottom: 12px; /* space below the icon */
  }

  .hide-text {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-weight: 500;
    font-size: 15px;
  }
`;

export const SideModal = ({
  onClose,
  children,
  width,
  closingType = 'close',
  disableBackdropClick = false,
  ...rest
}: SideModalProps) => {
  const handleClose = (event: React.MouseEvent<HTMLDivElement>) => {
    if (disableBackdropClick) {
      return;
    }
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal {...rest} onClose={onClose} disableEscapeKeyDown={false}>
      <div
        style={{ display: 'flex', height: '100vh', justifyContent: 'flex-end' }}
        onClick={handleClose}
      >
        {closingType === 'hide' && (
          <div style={{ width: '46px' }}>
            <HideButton variant="contained" onClick={onClose}>
              <IcArrowLeft className="hide-icon" />
              <span className="hide-text">Hide</span>
            </HideButton>
          </div>
        )}
        <ModalContent width={width}>
          {closingType === 'close' && (
            <CloseButton onClick={onClose}>
              <IcClose width={40} height={40} />
            </CloseButton>
          )}
          {children}
        </ModalContent>
      </div>
    </Modal>
  );
};
